// Zet een Timestamp om naar een Date, in elke vorm waarin hij bij de frontend
// aankomt: een Firestore Timestamp, epoch-milliseconden, de geserialiseerde
// vorm uit een Cloud Function ({ _seconds } of { seconds }), of een datumtekst.
//
// Nodig omdat deze omzetting als twee identieke kopieën in useOutputData en
// buildWeeklyProjectCounts stond, en de tooltip van de outputgrafiek een derde
// nodig had. toMillis (matrixDataHelpers) kent de Cloud Function-vorm niet.

/**
 * @param {*} ts - Timestamp in een van de vormen hierboven
 * @returns {Date|null} null als er niets of niets leesbaars is
 */
const toJsDate = (ts) => {
    if (!ts) return null
    if (typeof ts.toDate === 'function') return ts.toDate()
    if (typeof ts === 'number') return new Date(ts)
    if (typeof ts._seconds === 'number') return new Date(ts._seconds * 1000)
    if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000)
    const d = new Date(ts)
    return Number.isNaN(d.getTime()) ? null : d
}

/**
 * De dagsleutel van een outputgrafiek: hierop groepeert de grafiek haar punten
 * (useOutputData, sjabloonmodus in OutputData) en hierop zoekt de tooltip de
 * velden bij een punt (summarizeOutputFields). Eén definitie, zodat die twee
 * elkaar niet stil kwijtraken.
 *
 * @param {*} ts - Timestamp in een van de vormen van toJsDate
 * @returns {string|null} '12-5-2026', of null als er geen datum is
 */
export const toDateKey = (ts) => {
    const date = toJsDate(ts)
    return date ? date.toLocaleDateString('nl-NL') : null
}

export default toJsDate
